import { ReactSVG } from "react-svg";
import "./WidgetIcon.css";

const WidgetIcon = ({
  iconProp,
  heightProp = "4.3rem",
  widthProp = "4.3rem",
  widthIconProp = "100%",
  heightIconProp = "100%",
  backgroundColorProp,
  cursorProp = "pointer",
  handleOnClickProp,
  customClassNameProp,
  dataHoverDisabled,
}) => {
  const className = customClassNameProp ? `wi-1-frame-5 ${customClassNameProp}` : "wi-1-frame-5";

  return (
    <div
      className={className}
      style={{ height: heightProp, width: widthProp, background: backgroundColorProp, cursor: cursorProp, flexShrink: 0 }}
      onClick={handleOnClickProp}
      data-hover-disabled={dataHoverDisabled}
    >
      <ReactSVG
        src={iconProp}
        beforeInjection={(svg) => {
          svg.setAttribute("width", widthIconProp);
          svg.setAttribute("height", heightIconProp);
          svg.setAttribute("style", "overflow: visible;");
        }}
      />
    </div>
  );
};

export default WidgetIcon;
